export const IsNameValid = (name: string | undefined): boolean =>
  name !== undefined && name !== "";

export const IsEmailValid = (email: string | undefined): boolean =>
  email !== undefined &&
  email !== null &&
  email !== "" &&
  email.match(/^[^@\s]+@[^@\s]+\.[^@\s]+$/g) !== null;
